define('presentation/accountManager/facades/accountManagerFacade',[
    'externalDependencies/clientWebSocket'
], function () {
    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _accountManagerWebSocket = clientWebSocket.forApplication("accountManager");

    let _promiseFactory = null;

    const _getAccountManager = () => _promiseFactory.defer((promise) => {
        _accountManagerWebSocket.send("getAccountManager", {}, (response) => {
            promise.resolve(response);
        });
    });

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        let self = this;

        self.init = _init;
        self.getAccountManager = _getAccountManager;
    };
});

